import { Component, Input } from '@angular/core';
import { MedicalBillUpdate} from '@harlowe/core';
import { UtilService } from '@harlowe/core';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CardModule } from 'primeng/card';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { NgIf } from '@angular/common';
import { IMedicalBill } from '../../../models/medical-bill';
import { TealCompMedicalService } from '../../../services/medical.service';

@Component({
  selector: 'app-medical-bill-repricer',
  standalone: true,
  imports: [FloatLabelModule,CardModule,InputNumberModule,
            FormsModule,CheckboxModule, ButtonModule, NgIf],
  templateUrl: './medical-bill-repricer.component.html',
  styleUrl: './medical-bill-repricer.component.scss'
})
export class MedicalBillRepricerComponent 
{

  constructor(private _medicalService: TealCompMedicalService, private _utilService: UtilService)
  {

  }

  private _medicalBill: IMedicalBill = {} as IMedicalBill;

  @Input() set medicalBill (val: IMedicalBill)
  {

    this._medicalBill = val;
    this.overridePercentAmount = (val?.discountOverridePercent ?? 0) * 100;
    this.markupOverrideAmount = (val?.markupPercentOfCharges ?? 1) * 100;
  }

  get medicalBill() : IMedicalBill
  {
    return this._medicalBill;
  }


  @Input() encounterId?: number;
  @Input() locked: boolean = false;


  overridePercentAmount: number = 0;
  markupOverrideAmount: number = 0;
  billEdited: boolean = false;


  async manualDiscountChanged()
  {
    if(this.medicalBill && this.medicalBill.discountOverridePercent != this.overridePercentAmount/100)
    {
      this.billEdited = true; 
      this.medicalBill.discountOverridePercent = this.overridePercentAmount/100;
      await this.recalculateAllowedAmount();
    }
  }

  async manualMarkupChanged()
  {
    if(this.medicalBill && this.medicalBill.markupPercentOfCharges != this.markupOverrideAmount/100)
    {
      this.billEdited = true; 
      this.medicalBill.overrideDiscount = true;
      this.medicalBill.markupPercentOfCharges = this.markupOverrideAmount/100;
      await this.recalculateMarkedUpAmount();
    }
  }

  async recalculateAllowedAmount()
  {
    if(this.medicalBill)
    {
      var newAllowed = await this._medicalService.recalculateAllowedAmount(this.medicalBill.id,this.medicalBill.overrideDiscount ?? false,this.medicalBill.discountOverridePercent);
      this.medicalBill.confirmedAllowedAmount =newAllowed;
      this.medicalBill.gain = (this.medicalBill.confirmedMarkedUpAmount ?? 0) - newAllowed;

    }
  }

  async recalculateMarkedUpAmount()
  {
    if(this.medicalBill)
      {
        var newMarkedUp = await this._medicalService.recalculateMarkedUpAmount(this.medicalBill.id,this.medicalBill.overrideMarkup ?? false,this.medicalBill.markupPercentOfCharges);
        this.medicalBill.confirmedMarkedUpAmount = newMarkedUp;
        this.medicalBill.gain = newMarkedUp - (this.medicalBill.confirmedAllowedAmount ?? 0)
      }
  }

  async commitDiscountChanges()
  {
    if(this.medicalBill)
    {
      var eu = new MedicalBillUpdate(this.medicalBill.id);
      eu.overrideDiscount = this.medicalBill.overrideDiscount;
      eu.discountOverridePercent = this.medicalBill.discountOverridePercent;
      eu.overrideMarkup = this.medicalBill.overrideMarkup;
      eu.markupPercentOfCharges = this.medicalBill.markupPercentOfCharges;
      await this._medicalService.updateMedicalBill({billId:this.medicalBill.id, medicalBill:eu, encounterId:this.encounterId});
      this.billEdited = false;
    }
  }
}
